// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monthPopUpContainer_VQwru {
	top: 3px;
	left: 3px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 300px;
	gap: 10px;
	background-color: var(--f5-background);
	flex-direction: column;
	border-radius: 8px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	padding: 16px;
	position: absolute;
	z-index: 300000;
}
.topContainer_xLHds {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	flex-direction: column;
	gap: 3px;
}
.eventsContainer_nih7P {
	display: flex;
	width: 100%;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;
	max-height: 170px;
	overflow-y: auto;
	gap: 2px;
}
.closeButton_FZXFy {
	position: absolute;
	top: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	right: 12px;
	border-radius: 50%;
	width: 60px;
	height: 60px;
	transition: background 0.01s ease-in-out;
	svg {
		font-size: 30px;
		color: var(--_3c3a3a-color);
	}
	&:hover {
		background-color: var(--_16c0982e-background);
	}
}
.eventCard_pnW55 {
	display: flex;
	flex-direction: row;
	padding: 3px 5px;
	border-radius: 2px;
	width: 100%;
	gap: 7px;
	font-size: 12px;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	justify-content: flex-start;
	text-align: start;
	align-items: flex-start;
	&:hover {
		background: var(--border-color);
	}
}
.dot_bufVh {
	width: 8px;
	height: 8px;
	min-width: 8px;
	min-height: 8px;
	border-radius: 50%;
	background: var(--_16c09821-background);
	margin-top: 4px;

	&.active_pcrAy {
		background: var(--_10a37f-background);
	}
}
.eventText_jcjvD {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	font-size: 12px;
	color: var(--_3c3a3a-color);
}
.dayText_JH3UM {
	color: var(--_3c3a3a-color);
	font-size: 14px;
	font-weight: 400;
}

.dayNumber_yZtMy {
	margin-top: -5px;
	color: var(--_3c3a3a-color);
	font-size: 35px;
	font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/MonthPopUp.module.css"],"names":[],"mappings":"AAAA;CACC,QAAQ;CACR,SAAS;CACT,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,SAAS;CACT,sCAAsC;CACtC,sBAAsB;CACtB,kBAAkB;CAClB,wCAAwC;CACxC,aAAa;CACb,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,WAAW;CACX,sBAAsB;CACtB,QAAQ;AACT;AACA;CACC,aAAa;CACb,WAAW;CACX,uBAAuB;CACvB,2BAA2B;CAC3B,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;CAChB,QAAQ;AACT;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,wCAAwC;CACxC;EACC,eAAe;EACf,2BAA2B;CAC5B;CACA;EACC,6CAA6C;CAC9C;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,eAAe;CACf,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,2BAA2B;CAC3B,iBAAiB;CACjB,uBAAuB;CACvB;EACC,+BAA+B;CAChC;AACD;AACA;CACC,UAAU;CACV,WAAW;CACX,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,uCAAuC;CACvC,eAAe;;CAEf;EACC,qCAAqC;CACtC;AACD;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,eAAe;CACf,2BAA2B;AAC5B;AACA;CACC,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,2BAA2B;CAC3B,eAAe;CACf,gBAAgB;AACjB","sourcesContent":[".monthPopUpContainer {\n\ttop: 3px;\n\tleft: 3px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 300px;\n\tgap: 10px;\n\tbackground-color: var(--f5-background);\n\tflex-direction: column;\n\tborder-radius: 8px;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\tpadding: 16px;\n\tposition: absolute;\n\tz-index: 300000;\n}\n.topContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\twidth: 100%;\n\tflex-direction: column;\n\tgap: 3px;\n}\n.eventsContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n\tmax-height: 170px;\n\toverflow-y: auto;\n\tgap: 2px;\n}\n.closeButton {\n\tposition: absolute;\n\ttop: 12px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tright: 12px;\n\tborder-radius: 50%;\n\twidth: 60px;\n\theight: 60px;\n\ttransition: background 0.01s ease-in-out;\n\tsvg {\n\t\tfont-size: 30px;\n\t\tcolor: var(--_3c3a3a-color);\n\t}\n\t&:hover {\n\t\tbackground-color: var(--_16c0982e-background);\n\t}\n}\n.eventCard {\n\tdisplay: flex;\n\tflex-direction: row;\n\tpadding: 3px 5px;\n\tborder-radius: 2px;\n\twidth: 100%;\n\tgap: 7px;\n\tfont-size: 12px;\n\tcursor: pointer;\n\tuser-select: none;\n\tjustify-content: flex-start;\n\ttext-align: start;\n\talign-items: flex-start;\n\t&:hover {\n\t\tbackground: var(--border-color);\n\t}\n}\n.dot {\n\twidth: 8px;\n\theight: 8px;\n\tmin-width: 8px;\n\tmin-height: 8px;\n\tborder-radius: 50%;\n\tbackground: var(--_16c09821-background);\n\tmargin-top: 4px;\n\n\t&.active {\n\t\tbackground: var(--_10a37f-background);\n\t}\n}\n.eventText {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tfont-size: 12px;\n\tcolor: var(--_3c3a3a-color);\n}\n.dayText {\n\tcolor: var(--_3c3a3a-color);\n\tfont-size: 14px;\n\tfont-weight: 400;\n}\n\n.dayNumber {\n\tmargin-top: -5px;\n\tcolor: var(--_3c3a3a-color);\n\tfont-size: 35px;\n\tfont-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"monthPopUpContainer": `monthPopUpContainer_VQwru`,
	"topContainer": `topContainer_xLHds`,
	"eventsContainer": `eventsContainer_nih7P`,
	"closeButton": `closeButton_FZXFy`,
	"eventCard": `eventCard_pnW55`,
	"dot": `dot_bufVh`,
	"active": `active_pcrAy`,
	"eventText": `eventText_jcjvD`,
	"dayText": `dayText_JH3UM`,
	"dayNumber": `dayNumber_yZtMy`
};
export default ___CSS_LOADER_EXPORT___;
